import { render, staticRenderFns } from "./SkeletonSelectorCard.vue?vue&type=template&id=4f6aa644&"
import script from "./SkeletonSelectorCard.vue?vue&type=script&lang=js&"
export * from "./SkeletonSelectorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f6aa644')) {
      api.createRecord('4f6aa644', component.options)
    } else {
      api.reload('4f6aa644', component.options)
    }
    module.hot.accept("./SkeletonSelectorCard.vue?vue&type=template&id=4f6aa644&", function () {
      api.rerender('4f6aa644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/selector/fragment/SkeletonSelectorCard.vue"
export default component.exports